/* eslint-disable react/prop-types */
import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#3778C2';

const styles = StyleSheet.create({
	row: {
		flexDirection: 'row',
		alignItems: 'stretch',
		minHeight: 40,
	},

	cell: {
		fontSize: 8,
		padding: 5,
		borderRightWidth: 1,
		borderRightColor: borderColor,
		justifyContent: 'center',
		display: 'flex',
	},

	name: {
		width: '18%',
		textAlign: 'left',
		borderLeftWidth: 1,
		borderLeftColor: borderColor,
	},

	regionInfo: {
		width: '16%',
		textAlign: 'left',
	},

	pipelineChainage: {
		width: '24%',
		textAlign: 'center',
	},

	assettypeId: {
		width: '16%',
		textAlign: 'center',
	},

	remarks: {
		width: '16%',
		textAlign: 'left',
	},

	status: {
		width: '10%',
		textAlign: 'center',
		borderRightWidth: 1,
	},

	endborder: {
		borderBottomColor: borderColor,
		borderBottomWidth: 1,
		width: '100%',
	},
});

const InvoiceTableRow = (props) => {
	const rows = props.data?.map((item, index) => (
		<View key={index} wrap={false}>
			<View style={styles.row}>

				<Text style={[styles.cell, styles.name]}>
					{item?.name ?? 'N/A'}
				</Text>

				<Text style={[styles.cell, styles.regionInfo]}>
					{item?.regionInfo ?? 'N/A'}
				</Text>

				<Text style={[styles.cell, styles.pipelineChainage]}>
					{item?.pipelineChainage ?? 'N/A'}
				</Text>

				<Text style={[styles.cell, styles.assettypeId]}>
					{item?.assettypeId ?? 'N/A'}
				</Text>

				<Text style={[styles.cell, styles.remarks]}>
					{item?.remarks ?? 'N/A'}
				</Text>

				<Text style={[styles.cell, styles.status]}>
					{item?.status ?? 'N/A'}
				</Text>

			</View>

			<View style={styles.endborder} />
		</View>
	));

	return <>{rows}</>;
};

export default InvoiceTableRow;